// extracted by mini-css-extract-plugin
export default {"input":"UsersTableManagement_input__Xgh9Q"};